<template>
  <ds-multiple-select-filter
    v-model="employersSelected"
    :on-change="onEmployersChange"
    required>
    <ds-option
      v-for="employer in employers"
      :key="employer.id"
      :value="employer.id">
      {{ employer.name }}
    </ds-option>
  </ds-multiple-select-filter>
</template>

<script>
import { getAccountancyCompanies } from 'accountant/employer/employer/employerService';

export default {
  name: 'EmployerMultipleSelect',
  props: {
    employersSelectedCurrent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      employersSelected: this.employersSelectedCurrent.map(c => c.id),
      employers: [],
      key: 0,
    };
  },
  mounted() {
    this.fetchEmployers();
  },
  methods: {
    async fetchEmployers() {
      this.employers = await getAccountancyCompanies();
    },
    onEmployersChange(employerIds) {
      const employers = this.employers.filter(e => employerIds.includes(e.id));
      this.$emit('change-employers-selected', employers);
    },
  },
};
</script>
